import { PDFDocument, rgb } from 'pdf-lib';

export const editPdf = async (filetoedit, signCoordinates) => {
	const base64 = filetoedit.dataUrl;

	const pdfDoc = await PDFDocument.load(base64);
	if (pdfDoc) {
		const pages = pdfDoc.getPages();

		filetoedit.esign.length > 0
			&& filetoedit.esign?.forEach((singText) => {
				if (singText && !signCoordinates) {
					const finalSignatureText = singText.val;

					const fontSize = 14;
					const pageNo = singText?.coord?.pageNo - 1;

					// Getting page
					const page = pages[pageNo];

					page?.drawText(finalSignatureText, {
						x: singText?.coord.x, // X-coordinate of the text
						y: (page.getHeight() * (pageNo + 1)) - singText?.coord.y - 15, // Y-coordinate of the text
						size: fontSize, // Adjust size as needed
						color: rgb(0, 0, 0) // Black color,
					});
				}
			});

		if (signCoordinates) {
			for (const page of pages) {
				const pageWidth = page.getWidth();
				filetoedit.esign.length > 0
					&& filetoedit.esign?.forEach((singText, index) => {
						const textLength = singText.length;
						const startPos = pageWidth - 60;
						const mulitplier = Math.floor(startPos / 3);

						const rightSignPostion = startPos - (textLength * 5);

						const xcoord
							= index === 0
								? rightSignPostion
								: (index < 3
										&& startPos - (textLength * 2) - (mulitplier * index))
									|| startPos - (mulitplier * index);

						const updatexcoord
							= index === 4
								? rightSignPostion
								: (index < 7
										&& startPos - (textLength * 2) - (mulitplier * (index - 4)))
									|| startPos - (mulitplier * (index - 4));

						const largeXCoord
							= index === 8
								? rightSignPostion
								: (index < 10
										&& startPos - (textLength * 2) - (mulitplier * (index - 8)))
									|| startPos - (mulitplier * (index - 8));

						page?.drawText(singText, {
							x:
								index > 3 && index < 8
									? updatexcoord
									: (index > 7 && largeXCoord) || xcoord, // X-coordinate of the text
							y: index > 3 && index < 8 ? 30 : (index > 7 && 60) || 2, // Y-coordinate of the text
							size: 14, // Adjust size as needed
							color: rgb(0, 0, 0) // Black color,
						});
					});
			}
		}

		const modifiedPdfBytes = await pdfDoc.save();

		const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
		return blob;
	}
};
